import { render, staticRenderFns } from "./epubread.vue?vue&type=template&id=708b4918&scoped=true&"
import script from "./epubread.vue?vue&type=script&lang=js&"
export * from "./epubread.vue?vue&type=script&lang=js&"
import style0 from "./epubread.vue?vue&type=style&index=0&id=708b4918&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b4918",
  null
  
)

export default component.exports